<template>
    <Header :isLoginPage="true" />
    <SignIn></SignIn>
    <Footer></Footer>
</template>

<script>
  import Header from '@/components/Header.vue'
  import SignIn from '@/components/user/SignIn.vue'
  import Footer from '@/components/Footer.vue'

import {mapGetters,mapActions} from 'vuex'
  export default {
    components: {
        Header,
        SignIn,
        Footer
    },
      computed: {
        ...mapGetters([
            'isMobile'
        ]),
    },
  }
</script>

